module.exports = __webpack_public_path__ + "img/hands_and_keys.a4d2a95a.webp";